import { dataLayerConfig } from '@aspendental/shared-components-web';
export const dataLayer = (params: Record<string, unknown>) => {
	dataLayerConfig({
		event: 'appointment_step',
		...params,
	});
};
